import { useState } from "react";

export const useGetRandomColor = () => {
  const [usedTags, setUsedTags] = useState([]);

  const getRandomColor = () => {
    const colors = [
      "#8B77FF",
      "#6EDB34",
      "#24BCFE",
      "#FFA500",
      "#FF0000",
      "#ffee00",
    ];

    // no repeated colors
    const usedColors = usedTags.map((tag) => tag.bgColor);
    const availableColors = colors.filter(
      (color) => !usedColors.includes(color)
    );

    if (availableColors.length > 0) {
      const randomColor =
        availableColors[Math.floor(Math.random() * availableColors.length)];
      setUsedTags((prevUsedTags) => [
        ...prevUsedTags,
        { bgColor: randomColor },
      ]);
      return randomColor;
    }

    return colors[Math.floor(Math.random() * colors.length)];
  };
  return { getRandomColor };
};
